import theme from "@/theme";
export const stylesSentimentSliderWithChips = {
  chipStyle: (selectedChip: string[], chipValue: string) => ({
    borderRadius: "16px",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "14px",
    border: `1px solid ${theme.palette.custom.mainBlue}`,
    bgcolor: selectedChip.includes(chipValue)
      ? theme.palette.custom.mainBlue
      : theme.palette.custom.mainWhite,
    color: selectedChip.includes(chipValue) ? "white" : "#1D9BF0",
    "&:hover": {
      bgcolor: theme.palette.custom.mainBlue,
      color: theme.palette.custom.mainWhite,
    },
  }),
};
